/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.FormMetadataRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './FormMetadataRpc';
import * as Queries from './FormMetadataRpc.dfc.new';
import type { AdditionalContextArgs } from './FormMetadataRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetFormMetadataQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetFormMetadataResponseType>,
    References.GetFormMetadataRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getFormMetadata', References.GetFormMetadataResponseType>
        : References.GetFormMetadataResponseType)
    | undefined;
};

export function useGetFormMetadataQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetFormMetadataResponseType>,
    References.GetFormMetadataRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetFormMetadataQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_FORM_METADATA_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getFormMetadata: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetFormMetadataQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetFormMetadataQueryReturn<T>;
}

type UseGetFormMetadataLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetFormMetadataResponseType>,
    References.GetFormMetadataRequestType,
    T extends true
      ? Record<'getFormMetadata', References.GetFormMetadataResponseType>
      : References.GetFormMetadataResponseType
  >;

export function useGetFormMetadataLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetFormMetadataResponseType>,
    References.GetFormMetadataRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetFormMetadataLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_FORM_METADATA_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getFormMetadata: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetFormMetadataLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetFormMetadataLazyQueryReturn<T>;
}

type UseGetFormMetadataSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetFormMetadataResponseType>,
    References.GetFormMetadataRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getFormMetadata', References.GetFormMetadataResponseType>
    : References.GetFormMetadataResponseType;
};

export function useGetFormMetadataSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetFormMetadataResponseType>,
    References.GetFormMetadataRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetFormMetadataSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_FORM_METADATA_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getFormMetadata: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetFormMetadataSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetFormMetadataSuspenseQueryReturn<T>;
}
